import React from 'react';
import { MenuGroupProps } from '../__base';
import { CompanyPermissionConfig, CompanyUrl } from '@/routers/companyRouters';
import { BusReportIcon, HomeIcon, SaleReportIcon } from '@/assets/icons/entities/_';

const urls = CompanyUrl.Selling;

export const SellingMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: urls.Dashboard,
        permissions: CompanyPermissionConfig.__getPermission(urls.Dashboard),
      },
      {
        icon: <BusReportIcon />,
        title: 'menu.TripStatusReport',
        key: 'trip-status-reports',
        to: urls.TripStatusReport,
        permissions: CompanyPermissionConfig.__getPermission(urls.TripStatusReport),
      },
      {
        icon: <SaleReportIcon />,
        title: 'menu.Reports',
        key: 'reports',
        to: urls.SalesReport,
        permissions: CompanyPermissionConfig.__getPermission(urls.SalesReport),
        subMenu: [
          {
            title: 'menu.SalesReport',
            key: 'sales-report',
            to: urls.SalesReport,
            permissions: CompanyPermissionConfig.__getPermission(urls.SalesReport),
          },
          {
            title: 'menu.TripsReport',
            key: 'trips-report',
            to: urls.TripsReport,
            permissions: CompanyPermissionConfig.__getPermission(urls.TripsReport),
          },
          {
            title: 'menu.TripDetailReport',
            key: 'trip-details-report',
            to: urls.TripDetailsReport,
            permissions: CompanyPermissionConfig.__getPermission(urls.TripDetailsReport),
          },
          {
            title: 'menu.TripIncomeReport',
            key: 'trip-income-report',
            to: urls.TripIncomeReport,
            permissions: CompanyPermissionConfig.__getPermission(urls.TripIncomeReport),
          },
          {
            title: 'menu.UnEarnedRevenueReport',
            key: 'un-earned-revenue-report',
            to: urls.UnEarnedRevenueReport,
            permissions: CompanyPermissionConfig.__getPermission(urls.UnEarnedRevenueReport),
          },
          {
            title: 'menu.SaleWithGroupReport',
            key: 'sale-with-group-report',
            to: urls.SaleWithGroupReport,
            permissions: CompanyPermissionConfig.__getPermission(urls.SaleWithGroupReport),
          },
        ],
      },
    ],
  },
];
